import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'identifications',
            name: 'identification',
            class: 'Modules\\Identification\\Entities\\Identification'
        }
    }
}